import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Button, type IButtonProps } from 'shared/ui'
import { IntegrationsPath } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IIntegrationKey } from 'entities/Integrations'
import styles from './styles.module.scss'

export const ReconnectButton = observer(
  ({
    text = 'Reconnect',
    redirectKey,
    buttonProps,
  }: {
    text?: string
    redirectKey?: IIntegrationKey
    buttonProps?: IButtonProps
  }) => {
    const { userPermissionsStore } = useEntitiesContext()
    const { can_manage_integrations } = userPermissionsStore
    const redirectUrl = redirectKey
      ? `/${IntegrationsPath.root}/${redirectKey}`
      : `/${IntegrationsPath.root}`

    return (
      <Button
        tag='a'
        className={classnames(styles.reconnectButton, buttonProps?.className)}
        typeBtn={'contained'}
        contained={buttonProps?.contained || 'primary'}
        fullWidth={buttonProps?.fullWidth ?? true}
        text={text}
        href={can_manage_integrations ? redirectUrl : undefined}
        target='_blank'
        rel='noreferrer'
        disabled={!can_manage_integrations}
        tooltipProps={{
          label: !can_manage_integrations
            ? "You don't have access to this action. Contact your admin to request permission."
            : undefined,
          placement: 'top',
          breakWord: true,
          fullWidth: buttonProps?.fullWidth ?? true,
        }}
      />
    )
  }
)
